<template>
  <div class="w-full flex gap-4" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ label }}</div>
    <div class="flex-1">
      <field-selector v-model="fieldId" :field-name="select" @select="onSelect"/>
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";

export default {
  name: "SearchNavItemFieldSelectName",
  components: { FieldSelector },
  props: {
    label: {
      type: String,
      default: "",
    },
    value: String | null,
    size: {
      type: String,
      default: "normal",
    },
    widthClass: String,
  },
  computed: {
    getSearchType () {
      const query = this.$route.query;
      if (query.fieldName) {

        return query.fieldName
      }
      return this.select
    },
  },
  watch: {
    value: {
      handler(value) {
        this.select = value;
      },
    },
    select: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      select: this.value,
      fieldId: null,
    };
  },
  created() {
    this.select = this.getSearchType
    this.change(this.select);
  },
  methods: {
    onSelect(data) {
      if (data.field_name) {
        this.select = data.field_name
      } else {
        this.select = null;
        this.fieldId = null;
      }
    },
    change(data) {
      this.$emit("input", data);
    },
  }
};
</script>

<style lang="scss" scoped>
.title {
  //width: 114px !important;

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}
</style>
